<template>
    <div class="captail_wrap registrationSteps position-relative fullLoader p-0 customMobile-layout-cls">
        <loader v-if="pageLoader"></loader>
        <div class="loginContainerss whiteWithShadow scrollbar whiteBG w-100">
            <div class="col-12 loginLogo mobdesign">
                    <div class="mtLogo pt-3 position-relative">
                        <img width="170" src="../../../../static/website/images/logo.svg" alt="Logo">
                    </div>
                    </div>
            <div class="row m-0 justify-content-center align-items-center h-100 forgotPassword"> 
               
                <div class="col-12 col-lg-5">
                    <div class="restPass_form capitalLoginForm box-shadow topSpace">
                        <div class="lt-aler-message" v-if="notification_msg != ''">
                            <alert-notification />
                        </div>
                        <!-- <div class="text-center" v-show="!displayMessage">
                            <img width="60px" src="../../../../static/website/images/emailSend.png" class="mb-1 redt" :alt="$env_var.productName">
                        </div> -->
                        <div class="section_title text-center mb-4" v-show="!displayMessage">
                            <h3>Reset Password</h3>
                        </div>
                        <div class="stepForm text-center" v-show='displayMessage'>
                            <div class="resendMail restPp text-center">
                            <img src="../../../../static/website/images/group-9.svg" class="mb-1 successPaas" :alt="$env_var.productName">
                        </div>
                            <p class="alert alert-success">Password has been changed successfully.</p>
                            <router-link class="cap_btn blue pl-3 pr-3 large_btn" to="/">  login </router-link>
                        </div> 
                        <div class="row" v-show='!displayMessage && !screen2fa'>
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="position-relative">
                                        <label class="labeltext">New Password</label>
                                        <div class="position-relative">
                                            <input :type="show_new_pass" class="form-control" name="new" ref="new" v-model="newPass" v-validate="{ required: true, regex: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[*.!@$%^&():;<>,.?~_+]).{6,12}$/}" placeholder=" ">
                                            <password-icon class="icon" v-model="show_new_pass"></password-icon>
                                        </div>
                                        <span v-if="submitted" v-for="error in errors.collect('new')" class="text-danger">
                                            <span class="text-danger" v-if="error == 'The new field is required'">New Password is required</span>
                                            <span class="text-danger" v-if="error == 'The new field format is invalid'">Your password must contain minimum 6  and maximum 12 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^)</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                        <label class="labeltext">Confirm New Password</label>
                                        <div class="position-relative">
                                            <input :type="show_conf_pass" class="form-control" name="confirm" v-model="confirmPass" v-validate="{required: true, confirmed: newPass}" placeholder=" ">
                                            <password-icon class="icon" v-model="show_conf_pass"></password-icon>
                                        </div>
                                        <span v-if="submitted" v-for="error in errors.collect('confirm')" class="text-danger">
                                            <span class="text-danger" v-if="error == 'The confirm field is required'">Confirm New Password field is required</span> 
                                            <span class="text-danger" v-if="error == 'The confirm confirmation does not match'">does not match with new Password</span> 
                                        </span>
                                    
                                </div>
                            </div>
                            <!--<div class="col-12">
                                <div class="form-group">
                                    <input type="text" class="form-control otpPad" name="otp" v-model="otp" v-validate="'required'">
                                    <label class="labeltext">Google Authenticator Code</label>
                                    <input type="submit" class="mt-3 sendCode cap_btn blue pl-3 pr-3 large_btn" value="SEND CODE">
                                    <span v-show="submitted && errors.has('otp')" class="text-danger">Google Authenticator Code is required</span>
                                </div>
                            </div>-->
                            <div class="col-12 text-center my-4 d-flex align-items-center justify-content-between">
                                <input type="submit" class="cap_btn blue pl-3 pr-3 large_btn" value="Update" @click="submit()">
                                <div class="form-group text-center mt-2">
                                    <span> <router-link :to="'/'" class="donthaceaccount router-link-active">Back To Login ?</router-link></span>
                                </div>
                            </div>
                            <div class="col-12">
                                <p class="note alert alert-warning"><strong>Note:</strong> For security reasons, withdrawal requests option will be disabled for 24 hours after resetting your password.</p> 
                            </div>
                        </div> 
                        <div class="row" v-show='!displayMessage && screen2fa'>
                            <div class="col-12">
                                <div class="form-group">
                                    <div class="position-relative">
                                        <label class="labeltext w-100 text-center mb-4">Enter the 6 digit code from Google Authenticator.</label>
                                        <div class="position-relative">
                                            <input type="text" class="form-control" placeholder="Enter Otp" name="Otp" v-model="otp" maxlength="6" v-validate="screen2fa?'required|numeric|min:6':''" @keyup.enter="submit()">
                                        </div>
                                        <span v-show="submitted && errors.has('Otp')" class="text-danger">{{errors.first('Otp')}}</span>
                                        <div class="form-group text-right mt-2">
                                            <span> <router-link :to="'/'" class="donthaceaccount router-link-active">Back To Login ?</router-link></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex align-items-center justify-content-between my-4">
                                <input type="submit" class="cap_btn-b blue pl-3 pr-3" value="Previous" @click="screen2fa = false">
                                <input type="submit" class="cap_btn blue pl-3 pr-3 large_btn" value="Update" @click="submit()">
                            </div>
                            <div class="col-12">
                                <p class="note alert alert-warning mb-0"><strong>Note:</strong> For security reasons, withdrawal requests option will be disabled for 24 hours after resetting your password.</p> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
	export default {
		name: 'reset-password',
		data() {
			return {
				pageLoader : false,
                notification_msg:'',
                notification_type:'',
				submitted : false,
				displayMessage : false,
                screen2fa : false,
				oldPass : '',
				newPass : '',
				confirmPass : '',
				otp : '',
				show_old_pass: 'password',
				show_new_pass: 'password',
				show_conf_pass: 'password',
				hash : ''
			}
		},
		methods: {
			...mapActions({
                _runResetPasswordFromHash: types.RUN_RESET_PASSWORD_FROM_HASH
            }),
			submit(){
				const _that = this
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if (valid) {
                        if(_that.screen2fa){
    						let input_json={
                                'globalParams' :{
                                    "password": _that.newPass,
                                    "cpassword": _that.confirmPass,
                                    "hash": _that.hash,
                                    'otp' : _that.otp
                                },
                                'localParams':{ "parameter":_that }
    						}
    						_that._runResetPasswordFromHash(input_json)
                        }else{
                            _that.screen2fa = true
                            _that.submitted = false
                            _that.otp = ''
                        }
					}else{
                        alert(123)
                    }
				});
			},
		},
		created() {
			this.pageName('reset password')
			this.hash = this.$route.params.hash
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/website/user/reset-password.vue